module.exports = __webpack_public_path__ + "b09190313382f27b25a4b548732fc693.svg";